import requests from "../util";
import { GatewayInfo } from "./types";

const GATEWAY_URL = "/gateway";

const gatewayApi = {
  list: async (params?: { name?: string; limit?: number }): Promise<GatewayInfo[]> =>
    requests.get(GATEWAY_URL, { params }),

  getById: async (id: string): Promise<GatewayInfo> =>
    requests.get(`${GATEWAY_URL}/${id}`),

  getByName: async (name: string): Promise<GatewayInfo> =>
    requests.get(`${GATEWAY_URL}/name/${name}`),
};

export default gatewayApi;
